import { render, staticRenderFns } from "./ansCollFromRegFinalList.vue?vue&type=template&id=5d8b0af0&scoped=true&"
import script from "./ansCollFromRegFinalList.vue?vue&type=script&lang=js&"
export * from "./ansCollFromRegFinalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b0af0",
  null
  
)

export default component.exports